import React from "react";
import { TextOverflow } from "utils/common";
import { buildBulkSharableLink, buildSharableLink } from "widgets/modals/creatives/preview/sharing/utils";

export default function LinkTable(props){
	const {
		links = [],
		useVersionLinks,
	} = props;
	const rows = links.map((link) => {
		const adType = link.creative?.adType;
		const url = adType ? buildSharableLink(link.publicId, link.creative, useVersionLinks) : buildBulkSharableLink(link.publicId, links, useVersionLinks);
		return (
			<tr key={link.publicId}>
				<td className="name-col">
					<TextOverflow value={link.previewName} />
				</td>
				<td className="link-col">
					<a href={url} target="_blank">
						<TextOverflow value={url} />
					</a>
				</td>
			</tr>
		);
	});

	return (
		<table className="basic-table">
			<thead>
				<tr>
					<th className="name-col">Name</th>
					<th className="link-col">URL</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

LinkTable.displayName = "LinkTable";
LinkTable.defaultProps = {
	links: [],
	useVersionLinks: false,
};
